import apiClient from '../utils/api';

export interface SaveVendorOccasionsRequest {
  vendorId: string;
  occasionIds: string[];
}

export interface SaveVendorOccasionsResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export interface GetVendorOccasionsResponse {
  message: string;
  data: { occasions: Array<{ occasionId: string; title: string }> };
  timestamp: string;
}

export const vendorOccasionsService = {
  saveOccasions: async (data: SaveVendorOccasionsRequest): Promise<SaveVendorOccasionsResponse> => {
    const response = await apiClient.post<SaveVendorOccasionsResponse>(
      `/vendors/${data.vendorId}/occasions`,
      data
    );
    return response.data;
  },
  getVendorOccasions: async (vendorId: string): Promise<GetVendorOccasionsResponse> => {
    const response = await apiClient.get<GetVendorOccasionsResponse>(`/vendors/${vendorId}/occasions`);
    return response.data;
  },
};
